export const SET_TRIPS = 'SET_TRIPS'
export const SET_LOGIN_USER = 'SET_LOGIN_USER'
export const SET_TRIP_ID = 'SET_TRIP_ID'
export const SET_PROPOSALS = 'SET_PROPOSALS'
export const SET_PROPOSAL_ID = 'SET_PROPOSALS_ID'
export const SET_USERS = 'SET_USERS'
export const SET_USER_ID = 'SET_USER_ID'